function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 8px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import React, { PureComponent } from "react";
import styled from "styled-components";
import { connect as connectFormik, getIn } from "formik";
import Label from "../label";
import ResetTextareaButton from "../reset-button";
import { ErrorText, ItalicText } from "../text";
var Textarea = styled.textarea(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.components.native.textArea;
});
var TextareaWrapper = styled.div(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.components.textAreaWrapper;
});
var ErrorContainer = styled.div(_templateObject2());
var TextareaContainer = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(TextareaContainer, PureComponent);
    var _super = _createSuper(TextareaContainer);
    function TextareaContainer() {
        _classCallCheck(this, TextareaContainer);
        var _this;
        _this = _super.apply(this, arguments);
        // Only used if component is uncontrolled
        _this.state = {
            value: _this.props.initialValue || ""
        };
        _this.isControlled = "value" in _this.props;
        _this.handleChange = function(e) {
            return _this.setState({
                value: e.target.value
            });
        };
        _this.handleReset = function() {
            var _props, ref;
            return _this.isControlled ? (ref = (_props = _this.props).onChange) === null || ref === void 0 ? void 0 : ref.call(_props, {
                target: {
                    name: _this.props.name || "",
                    value: ""
                }
            }) : _this.setState({
                value: ""
            });
        };
        return _this;
    }
    var _proto = TextareaContainer.prototype;
    _proto.render = function render() {
        var _props = this.props, _label = _props.label, label = _label === void 0 ? "" : _label, withReset = _props.withReset, fullWidth = _props.fullWidth, propsValue = _props.value, propsOnChange = _props.onChange, error = _props.error, rest = _objectWithoutProperties(_props, [
            "label",
            "withReset",
            "fullWidth",
            "value",
            "onChange",
            "error"
        ]);
        var value = this.isControlled ? propsValue : this.state.value;
        var onChange = this.isControlled ? propsOnChange : this.handleChange;
        return /*#__PURE__*/ React.createElement(TextareaWrapper, {
            fullWidth: fullWidth
        }, label ? /*#__PURE__*/ React.createElement("label", null, /*#__PURE__*/ React.createElement(Label, null, label), /*#__PURE__*/ React.createElement(Textarea, _extends({
            value: value,
            onChange: onChange
        }, rest))) : /*#__PURE__*/ React.createElement(Textarea, _extends({
            value: value,
            onChange: onChange
        }, rest)), error && /*#__PURE__*/ React.createElement(ErrorContainer, null, /*#__PURE__*/ React.createElement(ItalicText, null, /*#__PURE__*/ React.createElement(ErrorText, null, error))), withReset && /*#__PURE__*/ React.createElement(ResetTextareaButton, {
            isVisible: !!value,
            onClick: this.handleReset
        }));
    };
    return TextareaContainer;
}(PureComponent);
var FormikTextarea = connectFormik(function(_param) {
    var formik = _param.formik, ref = _param.ref, rest = _objectWithoutProperties(_param, [
        "formik",
        "ref"
    ]);
    var value = getIn(formik.values, rest.name);
    var touched = getIn(formik.touched, rest.name);
    var error = touched ? getIn(formik.errors, rest.name) : null;
    return /*#__PURE__*/ React.createElement(TextareaContainer, _extends({
        error: error,
        value: value,
        onChange: formik.handleChange,
        onBlur: formik.handleBlur,
        ref: ref
    }, rest));
});
export { FormikTextarea };
export default TextareaContainer;
